<!--
  Inline failure notice. A failure message is never a modal (see CLAUDE.md),
  and this partial also renders in the sign-up flow, which has no toast
  container in its layout — so the error is surfaced inline, right above the
  form, where the sender is already looking.
-->
@if (inviteError && inviteNeedsVerification) {
  <!-- Not an error: a step is missing, and the notice offers it (#956). -->
  <div class="sn-invite-notice is-verify" role="status" data-test="invite-verify-first">
    <i class="fas fa-envelope-open-text" aria-hidden="true"></i>
    <div class="flex-grow-1">
      <p class="sn-invite-notice-title">Verify your email first</p>
      <p class="mb-2">{{ inviteError }}</p>
      <button type="button" class="sn-invite-link" [disabled]="verificationResend === 'sending'" (click)="resendVerification()">
        Send a new link
      </button>
      <span class="sn-invite-status" aria-live="polite">
        @if (verificationResend === 'sent') {
          Sent. Check your inbox.
        } @else if (verificationResend === 'failed') {
          We couldn't send it just now. Try again in a minute.
        }
      </span>
    </div>
    <button type="button" class="sn-invite-close" aria-label="Dismiss" (click)="dismissInviteError()">
      <i class="fas fa-xmark" aria-hidden="true"></i>
    </button>
  </div>
} @else if (inviteError) {
  <div class="sn-invite-notice is-error" role="alert">
    <i class="fas fa-triangle-exclamation" aria-hidden="true"></i>
    <p class="flex-grow-1 mb-0">{{ inviteError }}</p>
    <button type="button" class="sn-invite-close" aria-label="Dismiss error" (click)="dismissInviteError()">
      <i class="fas fa-xmark" aria-hidden="true"></i>
    </button>
  </div>
}

@if (!confirm) {
  <div class="invite-form">
    <form [formGroup]="inviteForm" (ngSubmit)="confirmData()">
      <!-- Input for email addresses -->
      <div class="cyber-input-wrapper">
        <label class="cyber-label" for="invite-email">
          <i class="fas fa-envelope me-2"></i>Email Addresses
        </label>
        <textarea title="Form text area"
          id="invite-email"
          formControlName="emails"
          class="cyber-input"
          placeholder="Enter comma-separated email addresses or one email per line"
          rows="4"
        >
        </textarea>
        <small class="form-text text-muted"
          >Separate multiple email addresses with commas.</small
        >
      </div>

      <!-- Optional: Input for custom invitation message -->
      <div class="cyber-input-wrapper">
        <label class="cyber-label" for="message">
          <i class="fas fa-comment me-2"></i>Personal Message (Optional)
        </label>
        <textarea title="Form text area"
          id="message"
          formControlName="message"
          class="cyber-input"
          placeholder="Optional: Add a personal message..."
          rows="3"
        >
        </textarea>
      </div>

      <!-- Submit button -->
      <div class="cyber-form-actions mt-4">
        <div class="d-flex justify-content-center gap-3">
          <button
            type="submit"
            class="btn-cyber btn-cyber-primary"
            [disabled]="!inviteForm.valid"
          >
            <i class="fas fa-paper-plane me-2"></i>Send Invite
          </button>
        </div>
      </div>

      <!-- "Skip for Now" button, similar to the other component -->
      @if (skipStep) {
        <div class="d-flex justify-content-center mt-3">
          <a
            [routerLink]="['/logging-in']"
            class="btn-cyber btn-cyber-secondary"
          >
            <i class="fas fa-forward me-2"></i>Skip for Now
          </a>
        </div>
      }
    </form>
  </div>
}
@if (confirm) {
  <div class="invite-confirm">
    @if (emails) {
      <div class="cyber-info-section mb-4">
        <h4 class="cyber-section-title">
          <i class="fas fa-envelope me-2"></i>Email Addresses:
        </h4>
        <div class="cyber-email-list">
          @for (email of emails; track email) {
            <div class="cyber-email-item">
              <i class="fas fa-at me-2"></i>{{ email }}
            </div>
          }
        </div>
      </div>
    }

    <div class="cyber-info-section mb-4">
      <h4 class="cyber-section-title">
        <i class="fas fa-comment me-2"></i>Your Message:
      </h4>
      <div class="cyber-message-content">
        {{ message || "No custom message provided" }}
      </div>
    </div>

    <div class="cyber-form-actions">
      <div class="d-flex justify-content-center gap-3">
        <button
          (click)="onSubmitInvite()"
          class="btn-cyber btn-cyber-primary"
          tabindex="0"
        >
          <i class="fas fa-check me-2"></i>Confirm & Send
        </button>
        <button
          (click)="confirm = false"
          class="btn-cyber btn-cyber-secondary"
          tabindex="1"
        >
          <i class="fas fa-edit me-2"></i>Edit Details
        </button>
      </div>
    </div>
  </div>
}
